/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { userlogoutUserAsync, userProfileInfoAsync } from "../../../../../app/modules/Auth/_redux";


export function UserProfileDropdown(props) {
	const { user, isLoading } = useSelector(state => state.auth);
	const dispatch = useDispatch()

	useEffect(()=> {
		dispatch(userProfileInfoAsync(user._id))
	}, [])

	const uiService = useHtmlClassService();
	const layoutProps = useMemo(() => {
		return {
			light: objectPath.get(uiService.config, "extras.user.dropdown.style") === "light",
		};
	}, [uiService]);

	//Logout api call
	const navigateToLogout = () => {
		let latestActivity = user.loginActivity[user.loginActivity.length - 1];
		dispatch(userlogoutUserAsync(user._id, latestActivity._id))
	}
	return (
		<Dropdown drop="down" alignRight>
			<Dropdown.Toggle
				as={DropdownTopbarItemToggler}
				id="dropdown-toggle-user-profile"
			>
				<div className={"btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"}>
					<span className="fn_s_14 f-w-400 color_blk opacity50 d-none d-md-inline mr-1">Hi,</span>
					<span className="fn_s_14 f-w-500 color_blk d-none d-md-inline mr-3">
						{user.fullName}
					</span>
					<span className="symbol symbol-35 symbol-light-success">
						{/* <span className="symbol-label afn_s_16 f-w-700 color_blk lblue rounded-circle">{ user.fullname[0] }</span> */}
						<img src={user.profilePicture} className="rounded-circle" alt="" />
					</span>
				</div>
			</Dropdown.Toggle>
			<Dropdown.Menu
				className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-sm asprodrpdwn">
				<>
					{/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
					{layoutProps.light && (<>
						<div className="d-flex align-items-center p-8 rounded-top">

							<div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0 aaa">
								<img src={toAbsoluteUrl("/media/users/300_21.jpg")} alt="" />
							</div>
							<div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">Sean Stone</div>
							<span className="label label-light-success label-lg font-weight-bold label-inline">3 messages</span>
						</div>
						<div className="separator separator-solid"></div>
					</>)}

					{!layoutProps.light && (

						<div className="p-5 text-center">
							<span className="symbol symbol-80 symbol-primary d-table m-auto">
								{/* <span className="symbol-label ap_18_600 font-weight-bold rounded">{user.fullname}</span> */}
								<img alt="Pic" className="hidden rounded" src={user.profilePicture} />
							</span>
							<div className="fn_s_16 f-w-700 color_blk m-auto pt-5 pb-0">
								{user.fullname}
							</div>
							<span className="afn_s_14 f-w-400 color_blk opacity50 d-table m-auto pb-5">
								{user.email}
							</span>
							<Link to="/profile-settings" className="btn btn-def-sm">
								Profile Setting
							</Link>
							<div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
								{user.firstName} {user.lastName}
							</div>

							{/* <span className="label label-success label-lg font-weight-bold label-inline">
                  3 messages
                </span> */}
						</div>
					)}
				</>

				<div className="navi navi-spacer-x-0 pt-0">
					<div className="navi-footer p-0 rounded-bottom">
						{/* <button onClick={navigateToLogout}> */}
						<button
							onClick={navigateToLogout}
							disabled={isLoading}
							className="btn rounded-0 py-3 btn-light-danger afn_s_12 w-100 uppercase lgtbtn"
						>
							LOGOUT
              				{isLoading && <span className="ml-3 spinner spinner-white"></span>}
						</button>
					</div>
				</div>
			</Dropdown.Menu>
		</Dropdown>
	);
}
